import React from 'react';

export default function KakaoSuccess() {
    return <div className="text-4xl">결제 성공</div>;
}
